"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AsyncSearchInputOption {
    constructor(label, value) {
        this.label = label;
        this.value = value;
    }
}
exports.default = AsyncSearchInputOption;
